import AbstractFilterClass from "./AbstractFilterClass";

export default class Favorites extends AbstractFilterClass {
    constructor() {
        super();
        this.list();

        this.pagination();
        this.filters();
    }

    list() {
        let self = this;
        this.appInitial = new Vue({
            el: '#app-favorites-list',
            delimiters: ['${', '}'],
            data: {
                priceFollow: false,
                categories: [],
                html: null,
                count: 0,
            },
            methods: {
                getFilterData: function (params) {
                    let selfV = this;

                    self.preloader(true);
                    $.ajax({
                        type: "POST",
                        url: gteFavoritesList,
                        data: params,
                        dataType: "json",
                    }).then(function (resp) {
                        if(resp.success) {
                            selfV.html = resp.data.html;
                            selfV.count = resp.data.count;
                        }
                        self.preloader(false);
                    });
                },

                changeFollow: function (params) {
                    self.preloader(true);
                    $.ajax({
                        type: "POST",
                        url: editFavorite,
                        data: params,
                        dataType: "json",
                    }).then(function (resp) {
                        self.preloader(false);
                    });
                },

                deleteItem: function (params) {
                    let selfV = this;

                    self.preloader(true);
                    $.ajax({
                        type: "POST",
                        url: deleteFavorite,
                        data: params,
                        dataType: "json",
                    }).then(function (resp) {
                        if(resp.success) {
                            selfV.html = resp.data.html;
                            selfV.count = resp.data.count;
                            selfV.categories = resp.data.categories;

                            $('.xhr-count-favorite').html(resp.data.count);
                        }
                        self.preloader(false);
                    });
                },
                getEnding: function (value) {
                    let titles = value.split('|'),
                        cases = [2, 0, 1, 1, 1, 2],
                        number = this.getCount;

                    return titles[ (number%100>4 && number%100<20)? 2 : cases[(number%10<5)?number%10:5] ];
                }
            },
            computed: {
                getFavorites: function () {
                    return this.html;
                },
                getCount: function () {
                    return this.count;
                },
                getCategories: function () {
                    return this.categories;
                },
            },
            mounted() {
                let selfV = this;
                $.ajax({
                    type: "POST",
                    url: gteFavoritesList,
                    dataType: "json",
                }).then(function (resp) {
                    if(resp.success) {
                        selfV.html = resp.data.html;
                        selfV.categories = resp.data.categories;
                        selfV.count = resp.data.count;
                    }
                });
            }
        });

        //Change follows
        $('#app-favorites-list').on('change', 'input[name="follow_price"]', function () {
            self.appInitial.changeFollow({
                id: $(this).attr('data-id'),
                follow_price: $(this).prop('checked')
            });
        });

        //Delete item
        $('#app-favorites-list').on('click', '.delete-item', function () {
            let id = $(this).attr('data-id'),
                confName = 'confirm:delete';

            //Confirm delete
            $(document).bind(confName, function () {
                $(document).unbind(confName);
                self.appInitial.deleteItem({
                    id: id,
                });
            });
            self.confirmDelete(confName);
        });
    }
}
